module.exports = __webpack_public_path__ + "media/images/gallery_2-a98bbaf8.jpg";